import React, { useRef } from "react";

import DoughnutDataset from "../types/DoughnutDataset";
import useDoughnut from "../hooks/useDoughnut";

import Card from "../../../common/Card/Card";
import Typography from "../../../common/Typography/Typography";

import styles from "./DoughnutSpecial.module.css";

interface Props {
    title?: string;
    datasets: DoughnutDataset[];
    total: number;
}

const DoughnutSpecial = ({ title, datasets, total }: Props) => {
    const ref = useRef(null);

    useDoughnut(ref, datasets);

    return (
        <Card padding="large" className={styles.card}>
            <div className={styles.mainContent}>
                <div className={styles.title}>
                    {title ? (
                        <Typography as="h3" variant="smallCaps">
                            {title}
                        </Typography>
                    ) : null}
                    <Typography as="div" variant="figure" fontSize="800" color="mint">
                        {total}
                    </Typography>
                </div>
                <div className={styles.doughnut}>
                    <canvas ref={ref} />
                </div>
            </div>
            <ul className={styles.figures}>
                {datasets.map(({ label, data, color }) => (
                    <li key={label}>
                        <dl className={styles.dataset}>
                            <Typography as="dt" variant="smallCaps" color="white">
                                {label}
                            </Typography>
                            <Typography as="dd" variant="figure" fontSize="800">
                                <span className="flex items-center gap-0.5">
                                    {data}
                                    <span className="w-1 h-1 rounded-full" style={{ backgroundColor: color }} />
                                </span>
                            </Typography>
                        </dl>
                    </li>
                ))}
            </ul>
        </Card>
    );
};

export default DoughnutSpecial;
